import { render, staticRenderFns } from "./FoldersTour.vue?vue&type=template&id=574b78b0&"
import script from "./FoldersTour.vue?vue&type=script&lang=js&"
export * from "./FoldersTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports